import { EnumItem } from '@core/models/enum-item.model';
import { EstimateTypeEnum } from '@enums/EstimateType';
import { StatusEnum } from '@enums/Status';

export const ESTIMATE_STATUS_ITEMS: EnumItem<StatusEnum>[] = Object.values(StatusEnum).map(status => ({
  key: status,
  titleKey: `STATUS.${status.toLocaleUpperCase()}`
}));

export const ESTIMATE_TYPE_ITEMS: EnumItem<EstimateTypeEnum>[] = Object.values(EstimateTypeEnum).map(type => ({
  key: type,
  titleKey: `ESTIMATE_TYPE.${type.toLocaleUpperCase()}`
}));

export const ESTIMATE_PROJECT_ITEMS: EnumItem<string>[] = [
  {
    key: 'MyProjects',
    titleKey: 'ESTIMATE_PROJECT.MYPROJECTS'
  }
];

export const PROJECT_ITEMS: EnumItem<string>[] = [
  {
    key: 'MyProjects',
    titleKey: 'ESTIMATE_PROJECT.MYPROJECTS'
  }
];
export const MY_PROJECTS_STORAGE_NAME = 'filterMyProjects';
